import React, { FunctionComponent } from "react";
import { SpinNumberInputField, TextInputField } from "@bps/fluent-ui";

interface MessageCreditsEventFormFieldsProps {
  tenantId: string;
}

export const MessageCreditsEventFormFields: FunctionComponent<MessageCreditsEventFormFieldsProps> = () => {
  return (
    <>
      <SpinNumberInputField label="Units" name="units" required />
      <TextInputField label="Details" name="details" required />
    </>
  );
};
